<template>
  <avtalat-input
    id="namn"
    v-model:value="namn"
    :label="label"
  />
</template>

<script setup lang="ts">
defineProps<{
  label: string;
}>();

const namn = defineModel<string>();
</script>
